// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Import jQuery and make it globally available
import $ from 'jquery';
global.$ = $;
global.jQuery = $;
window.$ = $;
window.jQuery = $;

import Rails from "@rails/ujs";
Rails.start();
global.Rails = Rails;
require("@rails/activestorage").start()
require("channels")
require('jquery')

import 'bootstrap'

require('inspinia_assets/pace.min')
require('inspinia_assets/jquery.metisMenu')
require('inspinia_assets/jquery.slimscroll.min')
require('inspinia')

require("@nathanvda/cocoon")

require('quality_reports')
require('consignee_address')
require('partner_tds_config')

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

window.jQuery = $;
window.$ = $;

$(function(){
  $("[data-hide]").on("click", function(){
    $("." + $(this).attr("data-hide")).hide();
    // -or-, see below
    // $(this).closest("." + $(this).attr("data-hide")).hide();
  });

  $('.show-more-link').on("click", function(event){
    event.preventDefault();
    var container = $(this).parent();
    container.find('.short-text').hide();
    container.find('.full-text').show();
    $(this).hide();
  });
});

window.updateParamsAndReload = function(name, val){
  var params = new URLSearchParams(window.location.search);
  params.delete(name);
  params.append(name, val);
  window.location = window.location.pathname + "?" + params.toString();
};

window.getIFSCcodeDetails = function(code, id){
  var url = "https://ifsc.razorpay.com/" + code;
  $.ajax({
      url : url,
      type : "get",
      async: false,
      success : function(data) {
        var transferType = "RTGS - " + data["RTGS"] + ", NEFT - " + data["NEFT"] + ", IMPS - " + data["IMPS"];

        var content = "<dl class='dl-horizontal row'>"
        content += "<dt class='col-sm-4'>Bank Name</dt>" + "<dd class='col-sm-8 m-b-sm'>" + data["BANK"] + "</dd>"
        content += "<dt class='col-sm-4'>Branch</dt>" + "<dd class='col-sm-8 m-b-sm'>" + data["BRANCH"] + "</dd>"
        content += "<dt class='col-sm-4'>Centre</dt>" + "<dd class='col-sm-8 m-b-sm'>" + data["CENTRE"] + "</dd>"
        content += "<dt class='col-sm-4'>Location</dt>" + "<dd class='col-sm-8 m-b-sm'>" + data["DISTRICT"] + ", " + data["STATE"] + "</dd>"
        content += "<dt class='col-sm-4'>Transfers</dt>" + "<dd class='col-sm-8 m-b-sm'>" + transferType + "</dd>"
        content += "</dl>"

        $(id).html(content);
        $('#customer_customer_bank_detail_attributes_bank_name').val(data["BANK"]).prop('readonly', true);
        $('#customer_customer_bank_detail_attributes_branch_name').val(data["BRANCH"]).prop('readonly', true);
      },
      error: function() {
        $(id).html("Invalid IFSC Code'");
      }
  });
};